export const nginxTags = [
  '/tags/captain-america',
  '/tags/captain-marvel',
  '/tags/cartoon-network',
  '/tags/cartoons-comics',
  '/tags/clearance-sale',
  '/tags/combos',
  '/tags/desi',
  '/tags/disney',
  '/tags/film-tv',
  '/tags/food',
  '/tags/friends',
  '/tags/funny',
  '/tags/gaming',
  '/tags/geeky',
  '/tags/hulk',
  '/tags/iron-man',
  '/tags/joker',
  '/tags/patterns',
  '/tags/punisher',
  '/tags/save-their-souls',
  '/tags/solar-activated',
  '/tags/solids',
  '/tags/spider-man',
  '/tags/superheroes',
  '/tags/sweat-activated',
  '/tags/the-flash',
  '/tags/thor',
  '/tags/travel',
  '/tags/wonder-woman',
  '/tags/x-men',
  '/tags/girl-power'
]



// WEBPACK FOOTER //
// ./src/assets/js/nginxTagsRedirection.js